import { defineComponent as o, createElementBlock as q, openBlock as e, mergeProps as r, createElementVNode as i, createCommentVNode as T } from "vue";
const n = ["width", "height"], h = {
  key: 0,
  d: "m480-453-95-95q-11-11-27.5-11T329-548q-12 12-12 28.5t12 28.5l123 123q12 12 28 12t28-12l124-124q12-12 11.5-28T631-548q-12-11-28-11.5T575-548l-95 95Zm0 373q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z"
}, a = {
  key: 1,
  d: "m480-507 95 95q11 11 27.5 11t28.5-11q12-12 12-28.5T631-469L508-592q-12-12-28-12t-28 12L328-468q-12 12-11.5 28t12.5 28q12 11 28 11.5t28-11.5l95-95Zm0 427q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z"
}, v = {
  key: 2,
  d: "m507-480-95 95q-11 11-11 27.5t11 28.5q12 12 28.5 12t28.5-12l123-123q12-12 12-28t-12-28L468-632q-12-12-28-11.5T412-631q-11 12-11.5 28t11.5 28l95 95ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z"
}, d = {
  key: 3,
  d: "m453-480 95-95q11-11 11-27.5t-11-28.5q-12-12-28.5-12t-28.5 12l-123 123q-12 12-12 28t12 28l124 124q12 12 28 11.5t28-11.5q11-12 11.5-28t-11.5-28l-95-95ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z"
}, D = /* @__PURE__ */ o({
  __name: "ArrowCircleIcon",
  props: {
    size: { default: 24 },
    variant: { default: "down" }
  },
  setup(l) {
    return (t, s) => (e(), q("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: t.size,
      height: t.size,
      viewBox: "0 -960 960 960",
      fill: "currentColor"
    }, [
      t.variant === "down" ? (e(), q("path", h)) : t.variant === "up" ? (e(), q("path", a)) : t.variant === "right" ? (e(), q("path", v)) : (e(), q("path", d))
    ], 8, n));
  }
}), p = ["width", "height"], P = /* @__PURE__ */ o({
  __name: "ArrowDropdownIcon",
  props: {
    size: { default: 24 }
  },
  setup(l) {
    return (t, s) => (e(), q("svg", r({
      width: t.size,
      height: t.size,
      viewBox: "0 -960 960 960",
      focusable: "false",
      fill: "currentColor"
    }, t.$attrs), s[0] || (s[0] = [
      i("path", { d: "M459-381 314-526q-3-3-4.5-6.5T308-540q0-8 5.5-14t14.5-6h304q9 0 14.5 6t5.5 14q0 2-6 14L501-381q-5 5-10 7t-11 2q-6 0-11-2t-10-7Z" }, null, -1)
    ]), 16, p));
  }
}), _ = ["height", "width", "fill"], G = /* @__PURE__ */ o({
  __name: "AttachFileIcon",
  props: {
    size: { default: 24 },
    color: { default: "currentColor" }
  },
  setup(l) {
    return (t, s) => (e(), q("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      height: `${t.size}px`,
      width: `${t.size}px`,
      viewBox: "0 -960 960 960",
      fill: t.color
    }, s[0] || (s[0] = [
      i("path", { d: "M720-330q0 104-73 177T470-80q-104 0-177-73t-73-177v-370q0-75 52.5-127.5T400-880q75 0 127.5 52.5T580-700v350q0 46-32 78t-78 32q-46 0-78-32t-32-78v-330q0-17 11.5-28.5T400-720q17 0 28.5 11.5T440-680v330q0 13 8.5 21.5T470-320q13 0 21.5-8.5T500-350v-350q-1-42-29.5-71T400-800q-42 0-71 29t-29 71v370q-1 71 49 120.5T470-160q70 0 119-49.5T640-330v-350q0-17 11.5-28.5T680-720q17 0 28.5 11.5T720-680v350Z" }, null, -1)
    ]), 8, _));
  }
}), u = ["height", "width", "fill"], J = /* @__PURE__ */ o({
  __name: "AudioLevelIcon",
  props: {
    size: { default: 18 },
    color: { default: "currentColor" },
    variant: { default: "default" }
  },
  setup(l) {
    return (t, s) => (e(), q("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      height: t.size,
      viewBox: "0 -960 960 960",
      width: t.size,
      fill: t.color
    }, s[0] || (s[0] = [
      i("path", { d: "M320 0q-17 0-28.5-11.5T280-40q0-17 11.5-28.5T320-80q17 0 28.5 11.5T360-40q0 17-11.5 28.5T320 0Zm160 0q-17 0-28.5-11.5T440-40q0-17 11.5-28.5T480-80q17 0 28.5 11.5T520-40q0 17-11.5 28.5T480 0Zm160 0q-17 0-28.5-11.5T600-40q0-17 11.5-28.5T640-80q17 0 28.5 11.5T680-40q0 17-11.5 28.5T640 0ZM480-400q-50 0-85-35t-35-85v-240q0-50 35-85t85-35q50 0 85 35t35 85v240q0 50-35 85t-85 35Zm-40 240v-84q-92-12-157.5-77T203-479q-2-17 9-29t28-12q17 0 28.5 11.5T284-480q14 70 69.5 115T480-320q72 0 127-45.5T676-480q4-17 15.5-28.5T720-520q17 0 28 12t9 29q-14 91-79 157t-158 78v84q0 17-11.5 28.5T480-120q-17 0-28.5-11.5T440-160Z" }, null, -1)
    ]), 8, u));
  }
}), c = ["width", "height"], K = /* @__PURE__ */ o({
  __name: "CameraFlipIcon",
  props: {
    size: { default: 24 }
  },
  setup(l) {
    return (t, s) => (e(), q("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: t.size,
      height: t.size,
      viewBox: "0 -960 960 960",
      fill: "currentColor"
    }, s[0] || (s[0] = [
      i("path", { d: "M618-424q-6 53-45 88.5T480-300q-8 0-16-1t-16-3q-8-2-17 0t-15 8q-11 11-8 26.5t17 20.5q14 5 27.5 7t27.5 2q79 0 136-53.5T678-426l9 8q9 8 21 8t20-8q9-9 9.5-21.5T729-461l-51-51q-11-11-28-11t-28 11l-51 51q-9 9-9 21t9 21q9 9 21 9t21-9l5-5Zm-336-30-9-8q-9-8-21-8t-20 8q-9 9-9.5 21.5T231-419l51 51q11 11 28 11t28-11l51-51q9-9 9-21t-9-21q-9-9-21-9t-21 9l-5 5q6-53 45-88.5t93-35.5q8 0 16 1t16 3q8 2 17 0t15-8q11-11 8-26.5T535-631q-14-5-27.5-7t-27.5-2q-79 0-136 53.5T282-454ZM160-120q-33 0-56.5-23.5T80-200v-480q0-33 23.5-56.5T160-760h126l50-54q11-12 26.5-19t32.5-7h170q17 0 32.5 7t26.5 19l50 54h126q33 0 56.5 23.5T880-680v480q0 33-23.5 56.5T800-120H160Zm0-80h640v-480H638l-73-80H395l-73 80H160v480Zm320-240Z" }, null, -1)
    ]), 8, c));
  }
}), m = ["width", "height"], f = {
  key: 0,
  d: "M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h480q33 0 56.5 23.5T720-720v180l126-126q10-10 22-5t12 19v344q0 14-12 19t-22-5L720-420v180q0 33-23.5 56.5T640-160H160Z"
}, Z = {
  key: 1,
  d: "M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h480q33 0 56.5 23.5T720-720v180l126-126q10-10 22-5t12 19v344q0 14-12 19t-22-5L720-420v180q0 33-23.5 56.5T640-160H160Zm0-80h480v-480H160v480Zm0 0v-480 480Z"
}, w = {
  key: 2,
  d: "M880-260 720-420v67l-80-80v-287H353l-80-80h367q33 0 56.5 23.5T720-720v180l160-160v440ZM822-26 26-822l56-56L878-82l-56 56ZM498-575ZM382-464ZM160-800l80 80h-80v480h480v-80l80 80q0 33-23.5 56.5T640-160H160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800Z"
}, O = /* @__PURE__ */ o({
  __name: "CameraIcon",
  props: {
    size: { default: 24 },
    variant: { default: "on" }
  },
  setup(l) {
    return (t, s) => (e(), q("svg", r({
      width: t.size,
      height: t.size,
      viewBox: "0 -960 960 960",
      focusable: "false",
      fill: "currentColor"
    }, t.$attrs), [
      t.variant === "on" ? (e(), q("path", f)) : t.variant === "off" ? (e(), q("path", Z)) : t.variant === "mute" ? (e(), q("path", w)) : T("", !0)
    ], 16, m));
  }
}), g = ["width", "height"], $ = {
  key: 0,
  d: "m240-240-92 92q-19 19-43.5 8.5T80-177v-623q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240Zm40-160h240q17 0 28.5-11.5T560-440q0-17-11.5-28.5T520-480H280q-17 0-28.5 11.5T240-440q0 17 11.5 28.5T280-400Zm0-120h400q17 0 28.5-11.5T720-560q0-17-11.5-28.5T680-600H280q-17 0-28.5 11.5T240-560q0 17 11.5 28.5T280-520Zm0-120h400q17 0 28.5-11.5T720-680q0-17-11.5-28.5T680-720H280q-17 0-28.5 11.5T240-680q0 17 11.5 28.5T280-640Z"
}, z = {
  key: 1,
  d: "m240-240-92 92q-19 19-43.5 8.5T80-177v-623q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240Zm-34-80h594v-480H160v525l46-45Zm-46 0v-480 480Zm120-80h240q17 0 28.5-11.5T560-440q0-17-11.5-28.5T520-480H280q-17 0-28.5 11.5T240-440q0 17 11.5 28.5T280-400Zm0-120h400q17 0 28.5-11.5T720-560q0-17-11.5-28.5T680-600H280q-17 0-28.5 11.5T240-560q0 17 11.5 28.5T280-520Zm0-120h400q17 0 28.5-11.5T720-680q0-17-11.5-28.5T680-720H280q-17 0-28.5 11.5T240-680q0 17 11.5 28.5T280-640Z"
}, Q = /* @__PURE__ */ o({
  __name: "ChatIcon",
  props: {
    size: { default: 24 },
    variant: { default: "off" }
  },
  setup(l) {
    return (t, s) => (e(), q("svg", r({
      width: t.size,
      height: t.size,
      viewBox: "0 -960 960 960",
      fill: "currentColor"
    }, t.$attrs), [
      t.variant === "on" ? (e(), q("path", $)) : (e(), q("path", z))
    ], 16, g));
  }
}), M = ["width", "height"], R = /* @__PURE__ */ o({
  __name: "EmojiIcon",
  props: {
    size: { default: 24 }
  },
  setup(l) {
    return (t, s) => (e(), q("svg", {
      width: t.size,
      height: t.size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, s[0] || (s[0] = [
      i("circle", {
        cx: "12",
        cy: "12",
        r: "10",
        stroke: "currentColor",
        "stroke-width": "2",
        fill: "none"
      }, null, -1),
      i("circle", {
        cx: "8",
        cy: "9",
        r: "1",
        fill: "currentColor"
      }, null, -1),
      i("circle", {
        cx: "16",
        cy: "9",
        r: "1",
        fill: "currentColor"
      }, null, -1),
      i("path", {
        d: "M8 15s1.5 2 4 2 4-2 4-2",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        fill: "none"
      }, null, -1)
    ]), 8, M));
  }
}), k = ["width", "height"], H = {
  key: 0,
  d: "M480-400q-50 0-85-35t-35-85v-240q0-50 35-85t85-35q50 0 85 35t35 85v240q0 50-35 85t-85 35Zm-40 240v-83q-92-13-157.5-78T203-479q-2-17 9-29t28-12q17 0 28.5 11.5T284-480q14 70 69.5 115T480-320q72 0 127-45.5T676-480q4-17 15.5-28.5T720-520q17 0 28 12t9 29q-14 91-79 157t-158 79v83q0 17-11.5 28.5T480-120q-17 0-28.5-11.5T440-160Z"
}, y = {
  key: 1,
  d: "m710-362-58-58q14-23 21-48t7-52h80q0 44-13 83.5T710-362ZM480-594Zm112 112-72-72v-206q0-17-11.5-28.5T480-800q-17 0-28.5 11.5T440-760v126l-80-80v-46q0-50 35-85t85-35q50 0 85 35t35 85v240q0 11-2.5 20t-5.5 18ZM440-120v-123q-104-14-172-93t-68-184h80q0 83 57.5 141.5T480-320q34 0 64.5-10.5T600-360l57 57q-29 23-63.5 39T520-243v123h-80Zm352 64L56-792l56-56 736 736-56 56Z"
}, C = {
  key: 2,
  d: "M480-400q-50 0-85-35t-35-85v-240q0-50 35-85t85-35q50 0 85 35t35 85v240q0 50-35 85t-85 35Zm0-240Zm-40 480v-83q-92-13-157.5-78T203-479q-2-17 9-29t28-12q17 0 28.5 11.5T284-480q14 70 69.5 115T480-320q72 0 127-45.5T676-480q4-17 15.5-28.5T720-520q17 0 28 12t9 29q-14 91-79 157t-158 79v83q0 17-11.5 28.5T480-120q-17 0-28.5-11.5T440-160Zm40-320q17 0 28.5-11.5T520-520v-240q0-17-11.5-28.5T480-800q-17 0-28.5 11.5T440-760v240q0 17 11.5 28.5T480-480Z"
}, U = /* @__PURE__ */ o({
  __name: "MicrophoneIcon",
  props: {
    size: { default: 24 },
    variant: { default: "on" }
  },
  setup(l) {
    return (t, s) => (e(), q("svg", r({
      width: t.size,
      height: t.size,
      viewBox: "0 -960 960 960",
      focusable: "false",
      fill: "currentColor"
    }, t.$attrs), [
      t.variant === "on" ? (e(), q("path", H)) : t.variant === "mute" ? (e(), q("path", y)) : (e(), q("path", C))
    ], 16, k));
  }
}), B = ["width", "height"], I = {
  key: 0,
  d: "M440-520h80v56q0 7 6 9.5t11-2.5l89-89q6-6 6-14t-6-14l-89-89q-5-5-11-2.5t-6 9.5v56h-80q-50 0-85 35t-35 85v40q0 17 11.5 28.5T360-400q17 0 28.5-11.5T400-440v-40q0-17 11.5-28.5T440-520ZM80-120q-17 0-28.5-11.5T40-160q0-17 11.5-28.5T80-200h800q17 0 28.5 11.5T920-160q0 17-11.5 28.5T880-120H80Zm80-120q-33 0-56.5-23.5T80-320v-440q0-33 23.5-56.5T160-840h640q33 0 56.5 23.5T880-760v440q0 33-23.5 56.5T800-240H160Z"
}, L = {
  key: 1,
  d: "M440-520h80v56q0 7 6 9.5t11-2.5l89-89q6-6 6-14t-6-14l-89-89q-5-5-11-2.5t-6 9.5v56h-80q-50 0-85 35t-35 85v40q0 17 11.5 28.5T360-400q17 0 28.5-11.5T400-440v-40q0-17 11.5-28.5T440-520ZM80-120q-17 0-28.5-11.5T40-160q0-17 11.5-28.5T80-200h800q17 0 28.5 11.5T920-160q0 17-11.5 28.5T880-120H80Zm80-120q-33 0-56.5-23.5T80-320v-440q0-33 23.5-56.5T160-840h640q33 0 56.5 23.5T880-760v440q0 33-23.5 56.5T800-240H160Zm0-80h640v-440H160v440Zm0 0v-440 440Z"
}, W = /* @__PURE__ */ o({
  __name: "ScreenShareIcon",
  props: {
    size: { default: 24 },
    variant: { default: "off" }
  },
  setup(l) {
    return (t, s) => (e(), q("svg", r({
      width: t.size,
      height: t.size,
      viewBox: "0 -960 960 960",
      focusable: "false",
      fill: "currentColor"
    }, t.$attrs), [
      t.variant === "on" ? (e(), q("path", I)) : (e(), q("path", L))
    ], 16, B));
  }
}), b = ["height", "width", "fill"], X = /* @__PURE__ */ o({
  __name: "SendIcon",
  props: {
    size: { default: 24 },
    color: { default: "currentColor" }
  },
  setup(l) {
    return (t, s) => (e(), q("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      height: `${t.size}px`,
      width: `${t.size}px`,
      viewBox: "0 -960 960 960",
      fill: t.color,
      style: "transform: rotate(-45deg)"
    }, s[0] || (s[0] = [
      i("path", { d: "M176-183q-20 8-38-3.5T120-220v-180l320-80-320-80v-180q0-22 18-33.5t38-3.5l616 260q25 11 25 37t-25 37L176-183Z" }, null, -1)
    ]), 8, b));
  }
}), S = ["width", "height"], A = {
  key: 0,
  d: "M433-80q-27 0-46.5-18T363-142l-9-66q-13-5-24.5-12T307-235l-62 26q-25 11-50 2t-39-32l-47-82q-14-23-8-49t27-43l53-40q-1-7-1-13.5v-27q0-6.5 1-13.5l-53-40q-21-17-27-43t8-49l47-82q14-23 39-32t50 2l62 26q11-8 23-15t24-12l9-66q4-26 23.5-44t46.5-18h94q27 0 46.5 18t23.5 44l9 66q13 5 24.5 12t22.5 15l62-26q25-11 50-2t39 32l47 82q14 23 8 49t-27 43l-53 40q1 7 1 13.5v27q0 6.5-2 13.5l53 40q21 17 27 43t-8 49l-48 82q-14 23-39 32t-50-2l-60-26q-11 8-23 15t-24 12l-9 66q-4 26-23.5 44T527-80h-94Zm49-260q58 0 99-41t41-99q0-58-41-99t-99-41q-59 0-99.5 41T342-480q0 58 40.5 99t99.5 41Z"
}, j = {
  key: 1,
  d: "M433-80q-27 0-46.5-18T363-142l-9-66q-13-5-24.5-12T307-235l-62 26q-25 11-50 2t-39-32l-47-82q-14-23-8-49t27-43l53-40q-1-7-1-13.5v-27q0-6.5 1-13.5l-53-40q-21-17-27-43t8-49l47-82q14-23 39-32t50 2l62 26q11-8 23-15t24-12l9-66q4-26 23.5-44t46.5-18h94q27 0 46.5 18t23.5 44l9 66q13 5 24.5 12t22.5 15l62-26q25-11 50-2t39 32l47 82q14 23 8 49t-27 43l-53 40q1 7 1 13.5v27q0 6.5-2 13.5l53 40q21 17 27 43t-8 49l-48 82q-14 23-39 32t-50-2l-60-26q-11 8-23 15t-24 12l-9 66q-4 26-23.5 44T527-80h-94Zm7-80h79l14-106q31-8 57.5-23.5T639-327l99 41 39-68-86-65q5-14 7-29.5t2-31.5q0-16-2-31.5t-7-29.5l86-65-39-68-99 42q-22-23-48.5-38.5T533-694l-13-106h-79l-14 106q-31 8-57.5 23.5T321-633l-99-41-39 68 86 64q-5 15-7 30t-2 32q0 16 2 31t7 30l-86 65 39 68 99-42q22 23 48.5 38.5T427-266l13 106Zm42-180q58 0 99-41t41-99q0-58-41-99t-99-41q-59 0-99.5 41T342-480q0 58 40.5 99t99.5 41Zm-2-140Z"
}, Y = /* @__PURE__ */ o({
  __name: "SettingsIcon",
  props: {
    size: { default: 24 },
    variant: { default: "off" }
  },
  setup(l) {
    return (t, s) => (e(), q("svg", r({
      width: t.size,
      height: t.size,
      viewBox: "0 -960 960 960",
      focusable: "false",
      fill: "currentColor"
    }, t.$attrs), [
      t.variant === "on" ? (e(), q("path", A)) : (e(), q("path", j))
    ], 16, S));
  }
}), E = ["width", "height"], F = {
  key: 0,
  d: "M760-481q0-83-44-151.5T598-735q-15-7-22-21.5t-2-29.5q6-16 21.5-23t31.5 0q97 43 155 131.5T840-481q0 108-58 196.5T627-153q-16 7-31.5 0T574-176q-5-15 2-29.5t22-21.5q74-34 118-102.5T760-481ZM280-360H160q-17 0-28.5-11.5T120-400v-160q0-17 11.5-28.5T160-600h120l132-132q19-19 43.5-8.5T480-703v446q0 27-24.5 37.5T412-228L280-360Zm380-120q0 42-19 79.5T591-339q-10 6-20.5.5T560-356v-250q0-12 10.5-17.5t20.5.5q31 25 50 63t19 80Z"
}, N = {
  key: 1,
  d: "M760-481q0-83-44-151.5T598-735q-15-7-22-21.5t-2-29.5q6-16 21.5-23t31.5 0q97 43 155 131.5T840-481q0 108-58 196.5T627-153q-16 7-31.5 0T574-176q-5-15 2-29.5t22-21.5q74-34 118-102.5T760-481ZM280-360H160q-17 0-28.5-11.5T120-400v-160q0-17 11.5-28.5T160-600h120l132-132q19-19 43.5-8.5T480-703v446q0 27-24.5 37.5T412-228L280-360Zm380-120q0 42-19 79.5T591-339q-10 6-20.5.5T560-356v-250q0-12 10.5-17.5t20.5.5q31 25 50 63t19 80ZM400-606l-86 86H200v80h114l86 86v-252ZM300-480Z"
}, x = /* @__PURE__ */ o({
  __name: "SpeakerIcon",
  props: {
    size: { default: 24 },
    variant: { default: "on" }
  },
  setup(l) {
    return (t, s) => (e(), q("svg", r({
      width: t.size,
      height: t.size,
      viewBox: "0 -960 960 960",
      focusable: "false",
      fill: "currentColor"
    }, t.$attrs), [
      t.variant === "on" ? (e(), q("path", F)) : (e(), q("path", N))
    ], 16, E));
  }
});
export {
  D as _,
  P as a,
  G as b,
  J as c,
  K as d,
  O as e,
  Q as f,
  R as g,
  U as h,
  W as i,
  X as j,
  Y as k,
  x as l
};
